import { unwrapConnection } from "src/app/shared/rxjs.pipes";
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef
} from "@angular/core";
import { IInvestigation } from "src/app/shared/interfaces/investigation.interfaces";
import { TimeEntryTypeService } from "../../../../shared/services/time-entry/time-entry-type/time-entry-type.service";
import {
  IApiInvestigationRoleNames,
  IApiTimeEntryType,
  IApiUpdateTimeEntryInput,
} from "src/app/shared/modules/graphql/types/types";
import { NgForm } from "@angular/forms";
import { untilDestroyed } from "@ngneat/until-destroy";
import { debounceTime } from "rxjs/operators";
import { NefcoDateHelper } from "src/app/shared/helpers/nefco-date.class";
import moment from "moment";
import { LoaderService } from "src/app/shared/modules/loader/loader.service";
import { IApiInvestigationStaffMember } from "../../investigations/investigation-time-and-exp-modal-kendo/investigation-time-and-exp-modal-kendo.component";
import { ExpenseActionType } from "src/app/shared/modules/graphql/enums/expense.enums";
import { timeEntryInvestigationHoursCreate, timeEntryInvestigationHoursList, timeEntryUnlinkedHoursCreate, timeEntryLinkedHoursCreteAll, timeEntryLinkedHoursUpdateAll, timeEntryUnlinkedHoursCreteAll, timeEntryUnlinkedHoursUpdateAll } from "src/app/shared/helpers/auth-config/time-expenses.config";
import { AuthService, UserService } from "src/app/shared/services";
import { NotificationsService } from "src/app/shared/modules/notifications/notifications.service";
import { AutoCompleteComponent } from "@progress/kendo-angular-dropdowns";
import {
  ADDITIONAL_ADMIN_WORK,
  ADMINISTRATIVE_HOURS_TYPE_NAME,
  ALL_BILLING_OPTIONS,
  AUTO_EQUIPMENT_EXPERT_ANALYSIS,
  BILLING_OPTIONS_MAP,
  BILLING_OPTION_SHORT_LABELS,
  CASE_REVIEW_FOR_DEPO_PREP,
  DESK_REVIEW_OC,
  EE_EXPERT_ANALYSIS,
  EE_REPORT,
  EE_TECH_REVIEW_NFPA_921,
  EVIDENCE_TECH_LAB_EXAM_ASSIST,
  EVIDENCE_TECH_REMOVAL_RETRIEVAL,
  EVIDENCE_TECH_TRANSFERRING,
  EXAM_WITH_HAZMAT,
  FIRE_PROTECTION_ENGINEER_EXAM,
  FOLLOW_UP_CASE_WORK,
  HVAC_EXPERT_ANALYSIS,
  INV_REPORT_WITH_CAPTIONED_PHOTOS,
  MASTER_ELECTRICIAN_EXPERT_ANALYSIS,
  OC_CONTINUED_WITH_JSE,
  OC_CONTINUED_WITH_LAB_EXAM,
  OC_EVIDENCE_TRANSPORT_SHIPPING,
  OC_ON_SCENE_EXAM,
  SENIOR_EE_EXPERT_ANALYSIS,
  SENIOR_EE_REPORT,
  TECH_REVIEW_NFPA_921,
  TESTIMONY_TIME,
  TRAINING_HOURS_TYPE_NAME,
  TRAINING_TIME,
  sortBillingOptions,
} from "src/app/shared/constants/billing-options.constants";
@Component({
  selector: "app-ind-time-form-kendo",
  templateUrl: "./ind-time-form-kendo.component.html",
  styleUrls: ["./ind-time-form-kendo.component.scss"],
})
export class IndTimeFormKendoComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild("autoCompleteTypeId", { static: false }) public autoCompleteTypeId!: AutoCompleteComponent;
  private readonly forceUnlinkedTypeNames = [ADMINISTRATIVE_HOURS_TYPE_NAME, TRAINING_HOURS_TYPE_NAME];

  private currentUser: any;

  public authConfig = {
    timeEntryUnlinkedHoursCreate,
    timeEntryInvestigationHoursList,
    timeEntryInvestigationHoursCreate,
    timeEntryLinkedHoursCreteAll,
    timeEntryLinkedHoursUpdateAll,
    timeEntryUnlinkedHoursCreteAll,
    timeEntryUnlinkedHoursUpdateAll
  }

  private _unlinked = false;

  private _timeEntry: IApiUpdateTimeEntryInput = {
    id: null,
    TypeId: null,
    workday: new Date(),
    hours: null,
    nonBillableHours: null,
    travelHours: null,
    nonBillableTravelHours: null,
    UserId: null,
    InvestigationId: null,
    description: "",
    billingDescription: "",
    paidDate: null,
  };

  private customTechDescription =
    "Technical Review in accordance with NFPA 921 section 4.6.2 Technical Review";

  public billingOptions = ALL_BILLING_OPTIONS;

  public get timeEntry() {
    return this._timeEntry;
  }

  @Input() public set timeEntry(val) {
    this._timeEntry = val;
    if (val?.paidDate) {
      this._timeEntry.paidDate = NefcoDateHelper.toLocal(
        this._timeEntry.paidDate
      );
      this.paidCheckbox = true;
    }
    if (!val.InvestigationId && val.id) {
      this._unlinked = true;
    }
    if (val && !val.billingDescription) {
      this._timeEntry.billingDescription = "";
    }
  }

  get isTimeEntryDisabled(): boolean {
    return !(
      this.actionType === 'ADD_TIME'
        ? this.timeEntryLinkedHoursCreteAllPermission?.enabled
        : this.timeEntryLinkedHoursUpdateAllPermission?.enabled
    );
  }

  @ViewChild("timeEntryTypeForm") form!: NgForm;
  @ViewChild("timeEntryInvestigationHoursCreate") timeEntryInvestigationHoursCreatePermission: any;
  @ViewChild("timeEntryUnlinkedHoursCreate") timeEntryUnlinkedHoursCreatePermission: any;
  @ViewChild("timeEntryUnlinkedHoursCreteAll") timeEntryUnlinkedHoursCreteAllPermission: any;
  @ViewChild("timeEntryUnlinkedHoursUpdateAll") timeEntryUnlinkedHoursUpdateAllPermission: any;
  @ViewChild("timeEntryLinkedHoursCreteAll") timeEntryLinkedHoursCreteAllPermission: any;
  @ViewChild("timeEntryLinkedHoursUpdateAll") timeEntryLinkedHoursUpdateAllPermission: any;

  @Input() actionType!: ExpenseActionType;
  @Input() investigations: IInvestigation[] = [];
  @Input() investigationStaffList: IApiInvestigationStaffMember[] = [];
  @Input() riskType: string | null = "";
  @Input() lossState: string | null = "";
  @Input() investigationView = false;
  @Input() adminView = false;
  @Input() modalView = false;
  @Input() editQtyOnly = false;
  @Input() forceUnlinkedMode = false;
  @Input() UserId = '';
  @Output() formSubmitted = new EventEmitter<IApiUpdateTimeEntryInput>();
  // For embedded views
  @Output() timeChange = new EventEmitter<IApiUpdateTimeEntryInput>();

  public timeEntryTypes: IApiTimeEntryType[] = [];
  private timeEntryTypesCopy: IApiTimeEntryType[] = [];
  public selectedTypeName = "";
  public typeIdsearch = "";
  ngAfterViewInit(): void {
    if (this.actionType === "ADD_TIME" && !this.forceUnlinkedMode) {
      this._unlinked = false;
    }
    if (this.forceUnlinkedMode) {
      this.unlinked = true;
      this.timeEntry.InvestigationId = null;
      this.timeEntry.travelHours = null;
      this.timeEntry.nonBillableTravelHours = null;
    }
    if (!this.timeEntryInvestigationHoursCreatePermission?.enabled || !this.timeEntryUnlinkedHoursCreatePermission?.enabled) {
      if (!this.timeEntryInvestigationHoursCreatePermission?.enabled && this.timeEntryUnlinkedHoursCreatePermission?.enabled) {
        this._unlinked = true;
      }
    }
    this.form?.valueChanges
      ?.pipe(debounceTime(300))
      .subscribe(() => {
        this.timeChange.emit(this.timeEntry);
      });
  }

  public disabledDates = (date: Date): boolean => {
    return moment(date).isAfter();
  };

  ngOnInit() {
    this.getTimeEntryTypes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.UserId?.currentValue) {
      this.getStaffWithPermissionRole(changes.UserId?.currentValue);
      // Clear type and billing only on actual dropdown user change (not on init)
      if (!changes.UserId.isFirstChange()) {
        this._timeEntry.TypeId = null;
        this.selectedTypeName = '';
        this._timeEntry.billingDescription = '';
      }
    }
    if (changes?.investigations?.previousValue !== changes?.investigations?.currentValue && this.currentUser) {
      this.setBillingOptions(this.currentUser);
    }
  }

  public getStaffWithPermissionRole(id: string) {
    this.loader.show$(this.userService.getByIdWithPermissionRoleAndState(id)).subscribe(user => {
      this.setDefaultTimeEntryTypeForUser(user);
    });
  }

  public get unlinked(): boolean {
    return this._unlinked;
  }

  public get isTechReview(): boolean {
    return this.selectedTypeName?.toLowerCase().includes('tech review');
  }

  public set unlinked(val: boolean) {
    if (this.forceUnlinkedMode && !val) {
      this._unlinked = true;
      return;
    }
    this._unlinked = val;
    this.timeEntry.TypeId = null;
    this.selectedTypeName = '';
    if (val === true) {
      this.timeEntry.InvestigationId = null;
      this.timeEntry.hours = 0;
    } else {
      this.timeEntry.hours = 0;
    }
  }

  public isPaidDate(date: Date) {
    return NefcoDateHelper.isPaidDate(date);
  }

  public paidCheckbox: boolean = false;

  constructor(
    private timeEntryTypeService: TimeEntryTypeService,
    private loader: LoaderService,
    private auth: AuthService,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private notifications: NotificationsService
  ) { }

  public onSubmit() {
    if (!this.isFormValid()) {
      return;
    }
    const timeEntry = {
      ...this.timeEntry,
      hours: this.timeEntry.hours || 0,
      nonBillableHours: this.timeEntry.nonBillableHours || 0,
      travelHours: this.timeEntry.travelHours,
      nonBillableTravelHours: this.timeEntry.nonBillableTravelHours,
    };
    this.formSubmitted.emit(timeEntry);
    this.form.form.reset();
    this.timeEntry.description = "";
  }

  // Set custom description on type change
  public typeChange(selectedId: string) {
    this.cdr.detectChanges();
    this.autoCompleteTypeId?.toggle(false);
    this._timeEntry.TypeId = selectedId || null;
    const foundType = this.timeEntryTypes.find(({ id }) => id === this._timeEntry.TypeId);
    this.selectedTypeName = foundType?.name || '';
    if (!this.timeEntry.id) {
      if (
        foundType?.name === "Investigation Hours: Tech Review Engineer" ||
        foundType?.name === "Investigation Hours: Tech Review Investigator" ||
        foundType?.name === "Investigation Hours: (CA) Tech Review Investigator"
      ) {
        this._timeEntry.description = this.customTechDescription;
      } else {
        this._timeEntry.description = "";
      }
    }
  }

  private getTimeEntryTypes() {
    this.loader
      .show$(this.timeEntryTypeService.get([]))
      .pipe(unwrapConnection())
      .subscribe((results) => {
        this.timeEntryTypes = results;
        this.timeEntryTypesCopy = results;
        this.applyTypeRestrictionsForUnlinkedMode();
        if (!this.adminView) {
          this.setDefaultTimeEntryTypeForLogin();
        }
        if (this.timeEntry?.TypeId) {
          this.typeChange(this.timeEntry.TypeId);
        }
        if (!this.timeEntry.id && this.unlinked) {
          this.onBillingOptionChange(true, TRAINING_TIME);
        }
      });
  }

  public get typeOptions(): IApiTimeEntryType[] {
    return this.timeEntryTypes;
  }

  private applyTypeRestrictionsForUnlinkedMode(): void {
    if (!this.forceUnlinkedMode) {
      return;
    }

    this.timeEntryTypes = (this.timeEntryTypes || []).filter((type) =>
      this.forceUnlinkedTypeNames.includes(type?.name || "")
    );
    this.timeEntryTypesCopy = [...this.timeEntryTypes];
  }

  sortTimeEntries(userRoleEntries: Array<string | null | undefined> = []) {
    this.timeEntryTypes = this.timeEntryTypesCopy;
    if (userRoleEntries?.length) {
      const normalizedRoleEntries = userRoleEntries.filter((entry): entry is string => !!entry);
      const userRoleEntriesArray = this.timeEntryTypes?.filter(entry => normalizedRoleEntries.includes(entry.name || "")) || [];
      const tempTimeEntries = this.timeEntryTypes?.filter(entry => !normalizedRoleEntries.includes(entry.name || "")) || [];
      this.timeEntryTypes = [...userRoleEntriesArray, ...tempTimeEntries];
    }
  }

  setDefaultTimeEntryTypeForUser(u: any) {
    this.currentUser = u;
    const userEntryType = u?.PermissionRoles[0]?.TimeEntryType;
    const userRoleEntries = u?.PermissionRoles?.map((role: any) => role?.TimeEntryType?.name);
    this.sortTimeEntries(userRoleEntries);
    this.setBillingOptions(u);
  }

  public setDefaultTimeEntryTypeForLogin() {
    this.auth.authenticatedUser.subscribe((u) => {
      this.setDefaultTimeEntryTypeForUser(u);
    });
  }

  public isFormValid(): boolean {
    this.form.control.markAllAsTouched();

    if (this.forceUnlinkedMode) {
      return this.form.form.valid;
    }

    const hasTravelHours = (typeof this.timeEntry.travelHours === 'number' && this.timeEntry.travelHours !== null) ||
      (typeof this.timeEntry.nonBillableTravelHours === 'number' && this.timeEntry.nonBillableTravelHours !== null);

    const isValid = this.form.form.valid && (this.isTechReview || ((hasTravelHours && !this.unlinked) || this.unlinked));

    if (!isValid && !this.isTechReview && !hasTravelHours && !this.unlinked) {
      this.notifications.error("At least one travel hour field must be entered", "Validation Error");
    }

    return isValid;
  }

  public changePaid(e: boolean) {
    if (!e) {
      this._timeEntry.paidDate = null;
    }
  }

  public isBillingOptionChecked(option: string): boolean {
    return (this._timeEntry.billingDescription || "") === option;
  }

  public onBillingOptionChange(checked: boolean, option: string): void {
    if (checked) {
      this._timeEntry.billingDescription = option;
      this.applyTimeEntryTypeForBillingOption(option);
    } else {
      this._timeEntry.billingDescription = "";
    }
    this.timeChange.emit(this.timeEntry);
  }

  public onInvestigationChange(investigationId: string): void {
    this.timeEntry.InvestigationId = investigationId || null;
    // Clear billing option checkboxes and type on investigation change
    this._timeEntry.billingDescription = '';
    this._timeEntry.TypeId = null;
    this.selectedTypeName = '';
    this.setBillingOptions(this.currentUser);
    this.timeChange.emit(this.timeEntry);
  }

  public getBillingOptionLabel(option: string): string {
    return BILLING_OPTION_SHORT_LABELS[option] || option;
  }

  private setBillingOptions(u: any) {
    if (!u) {
      this.billingOptions = ALL_BILLING_OPTIONS;
      return;
    }

    const userInStaff = this.getEffectiveInvestigationStaffList()?.find(
      (s) => s.userId === (u.id || u.UserId)
    );
    const roleTitle = userInStaff?.Role?.title;
    const uniqueRoles = [
      ...new Set([
        ...(u?.PermissionRoles?.map((role: any) =>
          this.normalizeRoleName(role?.name),
        ) ?? []),
        ...(roleTitle ? [roleTitle] : []),
      ]),
    ];
    if (this.unlinked) {
      this.billingOptions = BILLING_OPTIONS_MAP['Unlinked'];
    } else if (uniqueRoles.length > 0) {
      const combinedOptions = (uniqueRoles as string[]).reduce((acc, role) => {
        const optionsForRole = BILLING_OPTIONS_MAP[role];
        if (optionsForRole) {
          acc.push(...optionsForRole);
        }
        return acc;
      }, [] as string[]);

      this.billingOptions = sortBillingOptions([...new Set(combinedOptions)]);
    } else {
      this.billingOptions = ALL_BILLING_OPTIONS;
    }
  }

  private applyTimeEntryTypeForBillingOption(option: string): void {
    const matchedTypeId = this.resolveTimeEntryTypeIdForBillingOption(option);
    if (matchedTypeId) {
      this.typeChange(matchedTypeId);
      return;
    }

    const userEntryType = this.currentUser?.PermissionRoles?.[0]?.TimeEntryType;
    if (!this._timeEntry?.id && userEntryType?.id) {
      this.applyFallbackTimeEntryType(userEntryType?.id, userEntryType?.name, this.currentUser?.States);
    }
  }

  private getInvReportWithCaptionType(roleTitle: string | null, isCaliforniaLoss: boolean, isAutoRisk: boolean): string {
    if (roleTitle === IApiInvestigationRoleNames.MasterElectrician) {
      return this.getMasterElectricianTypeName(isCaliforniaLoss);
    } else {
      return this.getFireInvestigationTypeName(isCaliforniaLoss, isAutoRisk)
    }
  }

  private resolveTimeEntryTypeIdForBillingOption(option: string): string | null {
    const roleTitle = this.getCurrentRoleTitle();
    const isCaliforniaLoss = this.isCaliforniaLoss();
    const isAutoRisk = this.isAutoBoatOrHeavyEquipmentRisk();
    switch (option) {
      case OC_ON_SCENE_EXAM:
      case OC_CONTINUED_WITH_JSE:
      case OC_CONTINUED_WITH_LAB_EXAM:
      case INV_REPORT_WITH_CAPTIONED_PHOTOS:
        return this.findTypeIdByName(
          this.getInvReportWithCaptionType(roleTitle, isCaliforniaLoss, isAutoRisk)
        );
      case EXAM_WITH_HAZMAT:
        return this.resolveHazmatTypeId(roleTitle, isCaliforniaLoss);
      case MASTER_ELECTRICIAN_EXPERT_ANALYSIS:
        return this.findTypeIdByName(this.getMasterElectricianTypeName(isCaliforniaLoss));
      case AUTO_EQUIPMENT_EXPERT_ANALYSIS:
        return this.findTypeIdByName(this.getAutoHeavyEquipmentTypeName(isCaliforniaLoss))
      case HVAC_EXPERT_ANALYSIS:
        return this.findTypeIdByName("Investigation Hours: HVAC Hours");
      case EE_EXPERT_ANALYSIS:
        return this.findTypeIdByName(this.getElectricalEngineerTypeName(isCaliforniaLoss));
      case FIRE_PROTECTION_ENGINEER_EXAM:
        return this.findTypeIdByName("Investigation Hours: Fire Protection Engineer Hours");
      case SENIOR_EE_EXPERT_ANALYSIS:
      case SENIOR_EE_REPORT:
        return this.findTypeIdByName(this.getSrElectricalEngineerTypeName(isCaliforniaLoss));
      case EVIDENCE_TECH_REMOVAL_RETRIEVAL:
      case EVIDENCE_TECH_TRANSFERRING:
      case EVIDENCE_TECH_LAB_EXAM_ASSIST:
      case OC_EVIDENCE_TRANSPORT_SHIPPING:
        return this.findTypeIdByName(this.getEvidenceTechnicianTypeName(isCaliforniaLoss));
      case DESK_REVIEW_OC:
        return this.resolveDeskReviewTypeId(roleTitle, isCaliforniaLoss, false);
      case FOLLOW_UP_CASE_WORK:
        return this.resolveFollowUpTypeId(roleTitle, isCaliforniaLoss, isAutoRisk);
      case EE_REPORT:
        return this.resolveEeReportTypeId(roleTitle, isCaliforniaLoss);
      case CASE_REVIEW_FOR_DEPO_PREP:
        return this.resolveDepoPrepTypeId(roleTitle, isCaliforniaLoss, isAutoRisk);
      case TESTIMONY_TIME:
        return this.resolveTestimonyTypeId(roleTitle, isCaliforniaLoss, false);
      case TECH_REVIEW_NFPA_921:
        return this.resolveTechReviewTypeId(roleTitle, isCaliforniaLoss);
      case ADDITIONAL_ADMIN_WORK:
        return this.findTypeIdByName(ADMINISTRATIVE_HOURS_TYPE_NAME);
      case TRAINING_TIME:
        return this.findTypeIdByName(TRAINING_HOURS_TYPE_NAME);
      case EE_TECH_REVIEW_NFPA_921:
        return this.findTypeIdByName(this.getTechReviewEngineer(isCaliforniaLoss))
      default:
        return null;
    }
  }

  private resolveHazmatTypeId(roleTitle: string | null, isCaliforniaLoss: boolean): string | null {
    if (roleTitle === IApiInvestigationRoleNames.ElectricalEngineer) {
      return this.findTypeIdByName(this.getElectricalEngineerTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.SrElectricalEngineer) {
      return this.findTypeIdByName(this.getSrElectricalEngineerTypeName(isCaliforniaLoss));
    }

    if (
      roleTitle === IApiInvestigationRoleNames.Investigator ||
      roleTitle === IApiInvestigationRoleNames.FormerInvestigator
    ) {
      return this.findTypeIdByName(
        isCaliforniaLoss
          ? "Investigation Hours: (CA) Hazmat Hours"
          : "Investigation Hours: Hazmat Hours"
      );
    }

    return null;
  }

  private resolveDeskReviewTypeId(roleTitle: string | null, isCaliforniaLoss: boolean, isAutoRisk: boolean): string | null {
    if (
      roleTitle === IApiInvestigationRoleNames.Investigator ||
      roleTitle === IApiInvestigationRoleNames.FormerInvestigator
    ) {
      return this.findTypeIdByName(this.getFireInvestigationTypeName(isCaliforniaLoss, isAutoRisk));
    }

    if (roleTitle === IApiInvestigationRoleNames.ElectricalEngineer) {
      return this.findTypeIdByName(this.getElectricalEngineerTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.SrElectricalEngineer) {
      return this.findTypeIdByName(this.getSrElectricalEngineerTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.HvacExpert) {
      return this.findTypeIdByName("Investigation Hours: HVAC Hours");
    }

    if (roleTitle === IApiInvestigationRoleNames.AutoExpert) {
      return this.findTypeIdByName(this.getAutoHeavyEquipmentTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.FireProtectionEngineer) {
      return this.findTypeIdByName("Investigation Hours: Fire Protection Engineer Hours");
    }

    return null;
  }

  private resolveFollowUpTypeId(roleTitle: string | null, isCaliforniaLoss: boolean, isAutoRisk: boolean): string | null {
    if (
      roleTitle === IApiInvestigationRoleNames.Investigator ||
      roleTitle === IApiInvestigationRoleNames.FormerInvestigator
    ) {
      return this.findTypeIdByName(this.getFireInvestigationTypeName(isCaliforniaLoss, isAutoRisk));
    }

    if (roleTitle === IApiInvestigationRoleNames.ElectricalEngineer) {
      return this.findTypeIdByName(this.getElectricalEngineerTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.SrElectricalEngineer) {
      return this.findTypeIdByName(this.getSrElectricalEngineerTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.MasterElectrician) {
      return this.findTypeIdByName(this.getMasterElectricianTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.HvacExpert) {
      return this.findTypeIdByName("Investigation Hours: HVAC Hours");
    }

    if (roleTitle === IApiInvestigationRoleNames.AutoExpert) {
      return this.findTypeIdByName(this.getAutoHeavyEquipmentTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.FireProtectionEngineer) {
      return this.findTypeIdByName("Investigation Hours: Fire Protection Engineer Hours");
    }

    return null;
  }

  private resolveEeReportTypeId(roleTitle: string | null, isCaliforniaLoss: boolean): string | null {
    if (roleTitle === IApiInvestigationRoleNames.ElectricalEngineer) {
      return this.findTypeIdByName(this.getElectricalEngineerTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.SrElectricalEngineer) {
      return this.findTypeIdByName(this.getSrElectricalEngineerTypeName(isCaliforniaLoss));
    }

    return null;
  }

  private resolveDepoPrepTypeId(roleTitle: string | null, isCaliforniaLoss: boolean, isAutoRisk: boolean): string | null {
    if (
      roleTitle === IApiInvestigationRoleNames.Investigator ||
      roleTitle === IApiInvestigationRoleNames.FormerInvestigator
    ) {
      return this.findTypeIdByName(this.getFireInvestigationTypeName(isCaliforniaLoss, isAutoRisk));
    }

    if (roleTitle === IApiInvestigationRoleNames.MasterElectrician) {
      return this.findTypeIdByName(this.getMasterElectricianTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.ElectricalEngineer) {
      return this.findTypeIdByName(this.getElectricalEngineerTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.SrElectricalEngineer) {
      return this.findTypeIdByName(this.getSrElectricalEngineerTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.HvacExpert) {
      return this.findTypeIdByName("Investigation Hours: HVAC Hours");
    }

    if (roleTitle === IApiInvestigationRoleNames.AutoExpert) {
      return this.findTypeIdByName(this.getAutoHeavyEquipmentTypeName(isCaliforniaLoss));
    }

    if (roleTitle === IApiInvestigationRoleNames.FireProtectionEngineer) {
      return this.findTypeIdByName("Investigation Hours: Fire Protection Engineer Hours");
    }

    return null;
  }

  private resolveTestimonyTypeId(roleTitle: string | null, isCaliforniaLoss: boolean, isAutoRisk: boolean): string | null {
    if (
      roleTitle === IApiInvestigationRoleNames.Investigator ||
      roleTitle === IApiInvestigationRoleNames.FormerInvestigator
    ) {
      return this.findTypeIdByName(
        this.getFireInvestigationTypeName(isCaliforniaLoss, isAutoRisk, true)
      );
    }

    if (roleTitle === IApiInvestigationRoleNames.ElectricalEngineer) {
      return this.findTypeIdByName(this.getElectricalEngineerTypeName(isCaliforniaLoss, true));
    }

    if (roleTitle === IApiInvestigationRoleNames.FireProtectionEngineer) {
      return this.findTypeIdByName("Testimony Hours: Fire Protection Engineer Hours");
    }

    if (roleTitle === IApiInvestigationRoleNames.HvacExpert) {
      return this.findTypeIdByName("Testimony Hours: HVAC Hours");
    }

    if (roleTitle === IApiInvestigationRoleNames.MasterElectrician) {
      return this.findTypeIdByName("Testimony Hours: Master Electrician Hours");
    }

    return null;
  }

  private resolveTechReviewTypeId(roleTitle: string | null, isCaliforniaLoss: boolean): string | null {
    if (roleTitle === IApiInvestigationRoleNames.TechReviewer) {
      return this.findTypeIdByName(
        isCaliforniaLoss
          ? "Investigation Hours: (CA) Tech Review Investigator"
          : "Investigation Hours: Tech Review Investigator"
      );
    }

    if (roleTitle === IApiInvestigationRoleNames.EngineerTechReviewer) {
      return this.findTypeIdByName("Investigation Hours: Tech Review Engineer");
    }

    return null;
  }

  private getFireInvestigationTypeName(isCaliforniaLoss: boolean, isAutoRisk: boolean, isTestimony = false): string {
    const prefix = isTestimony ? "Testimony Hours:" : "Investigation Hours:";

    if (isAutoRisk) {
      return isCaliforniaLoss
        ? `${prefix} (CA) Auto & Heavy Equipment`
        : `${prefix} Auto & Heavy Equipment`;
    }

    return isCaliforniaLoss
      ? `${prefix} (CA) Fire Investigator Hours`
      : `${prefix} Fire Investigator Hours`;
  }

  private getElectricalEngineerTypeName(isCaliforniaLoss: boolean, isTestimony = false): string {
    const prefix = isTestimony ? "Testimony Hours:" : "Investigation Hours:";
    return isCaliforniaLoss
      ? `${prefix} (CA) Electrical Engineering Hours`
      : `${prefix} Electrical Engineering Hours`;
  }

  private getMasterElectricianTypeName(isCaliforniaLoss: boolean): string {
    return isCaliforniaLoss
      ? "Investigation Hours: (CA) Master Electrician Hours"
      : "Investigation Hours: Master Electrician Hours";
  }

  private getEvidenceTechnicianTypeName(isCaliforniaLoss: boolean): string {
    return isCaliforniaLoss
      ? "Investigation Hours: (CA) Evidence Technician Hours"
      : "Investigation Hours: Evidence Technician Hours";
  }

  private getSrElectricalEngineerTypeName(isCaliforniaLoss: boolean): string {
    return isCaliforniaLoss
      ? "Investigation Hours: (CA) Sr Electrical Engineering Hours"
      : "Investigation Hours: Sr Electrical Engineering Hours";
  }

  private getAutoHeavyEquipmentTypeName(isCaliforniaLoss: boolean): string {
    return isCaliforniaLoss
      ? "Investigation Hours: (CA) Auto & Heavy Equipment"
      : "Investigation Hours: Auto & Heavy Equipment";
  }
  private getTechReviewEngineer(isCaliforniaLoss: boolean): string {
    return isCaliforniaLoss
      ? "Investigation Hours: (CA) Tech Review Engineer"
      : "Investigation Hours: Tech Review Engineer";
  }

  private findTypeIdByName(typeName: string): string | null {
    if (!typeName) {
      return null;
    }

    const matchedType = this.timeEntryTypes?.find((type) =>
      this.normalizeValue(type?.name || "") === this.normalizeValue(typeName)
    );

    return matchedType?.id || null;
  }

  private getCurrentRoleTitle(): string | null {
    const currentUserId = this._timeEntry?.UserId || this.UserId || this.currentUser?.id || this.currentUser?.UserId;
    const userInStaff = this.getEffectiveInvestigationStaffList()?.find((staff) =>
      staff?.userId === currentUserId || staff?.User?.id === currentUserId
    );

    return userInStaff?.Role?.title || null;
  }

  private getEffectiveInvestigationStaffList(): IApiInvestigationStaffMember[] {
    if (this.investigationStaffList?.length) {
      return this.investigationStaffList;
    }

    const selectedInvestigation = this.getCurrentInvestigation() as any;
    const selectedStaff = selectedInvestigation?.InvestigationStaff || [];

    if (!selectedStaff?.length) {
      return [];
    }

    return selectedStaff.map((staff: any) => ({
      ...staff,
      userId: staff?.userId || staff?.User?.id,
      userName: staff?.userName || `${staff?.User?.firstName || ""} ${staff?.User?.lastName || ""}`.trim(),
    }));
  }

  private getCurrentInvestigation(): IInvestigation | null {
    if (!this.timeEntry?.InvestigationId || !this.investigations?.length) {
      return null;
    }

    return this.investigations.find((investigation) => investigation?.id === this.timeEntry?.InvestigationId) || null;
  }

  private isCaliforniaLoss(): boolean {
    return this.normalizeValue(this.getCurrentLossState()) === "ca";
  }

  private getCurrentLossState(): string {
    return this.lossState || this.getCurrentInvestigation()?.LossAddress?.state || "";
  }

  private isAutoBoatOrHeavyEquipmentRisk(): boolean {
    const normalizedRiskType = this.normalizeValue(this.riskType || this.getCurrentInvestigation()?.RiskType?.name || "");
    return ["auto", "boat", "heavy equipment"].some((value) => normalizedRiskType.includes(value));
  }

  private applyFallbackTimeEntryType(userEntryTypeId: string, userEntryTypeName: string, states: string[]): void {
    const match = this.findMatchingString(
      userEntryTypeName,
      this.timeEntryTypes?.filter((type) => type.id !== userEntryTypeId)?.map((type) => type.name || "")
    );

    if (states?.includes("CA") && match) {
      const matchType = this.timeEntryTypes?.find((type) => this.normalizeValue(type?.name || "") === this.normalizeValue(match));
      if (matchType?.id) {
        this._timeEntry.TypeId = matchType.id;
        this.typeChange(matchType.id);
        return;
      }
    }

    this._timeEntry.TypeId = userEntryTypeId;
    this.typeChange(this._timeEntry.TypeId);
  }

  private normalizeValue(value?: string | null): string {
    return (value || "")
      .replace(/&amp;/gi, "&")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  private findMatchingString(type: string, types: Array<string | null | undefined> = []): string | null {
    const words = new Set(this.normalizeValue(type).split(' '));

    for (const str of types) {
      const strWords = new Set(this.normalizeValue(str).split(' '));

      const isMatch = [...words].every(word => strWords.has(word));

      if (isMatch) {
        return str || null;
      }
    }

    return null;
  }

  private normalizeRoleName = (value?: string): string => {
    const normalized = value
      ?.trim()
      .toUpperCase()
      .replace(/\s+/g, '_')
      .replace(/[^A-Z0-9_]/g, '') ?? '';

    return normalized === 'ADMIN'
      ? IApiInvestigationRoleNames.AdministrativeStaff
      : normalized;
  };

}
